import { render, staticRenderFns } from "./menuOpc.vue?vue&type=template&id=94b5084c&scoped=true&"
import script from "./menuOpc.vue?vue&type=script&lang=js&"
export * from "./menuOpc.vue?vue&type=script&lang=js&"
import style0 from "./menuOpc.vue?vue&type=style&index=0&id=94b5084c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b5084c",
  null
  
)

export default component.exports